import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import "./index.css";

function NavBar() {
  const [navColour, updateNavbar] = useState(false);
  const { pathname } = useLocation();

  function scrollHandler() {
    if (window.scrollY >= 1) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  const navlinks = [
    {
      id: "Home",
      label: "Home",
      to_link: "/",
    },
    {
      id: "About",
      label: "About",
      to_link: "/about",
    },
    {
      id: "Projects",
      label: "Projects",
      to_link: "/projects",
    },
  ];

  const navigate = useNavigate();
  return (
    <div
      className={`${navColour ? "navbar-fixed" : "navbar-container"}`}
      style={{ marginTop: pathname === "/" ? "3em" : "" }}
    >
      <div className={`${navColour ? "nav-fixed" : "navbar"}`}>
        <div className="nav-links">
          {navlinks.map((link) => {
            return (
              <div
                id={link.id}
                className="nav-link"
                onClick={() => navigate(link.to_link)}
              >
                {link.label}
              </div>
            );
          })}
        </div>
        {/* </Container> */}
      </div>
    </div>
  );
}

export default NavBar;
